// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deposit-widget[data-v-a6e7eed2] {\n  background-color: #1f2223;\n  box-shadow: var(--magic-shadow, rgba(0, 0, 0, 0.4));\n  max-width: 343px;\n}", ""]);
// Exports
module.exports = exports;
